// extracted by mini-css-extract-plugin
export default {"dark-mode-btn":"Navbar_dark-mode-btn__2paL2","dark-mode-btn--active":"Navbar_dark-mode-btn--active__Mdf9-","dark-mode-btn__icon":"Navbar_dark-mode-btn__icon__8Ty-B"};